<script lang="ts">
  import { computed, type HTMLAttributes } from 'vue'
  export interface FieldStackProps {
    class?: HTMLAttributes['class']
    fieldType?: 'default' | 'inset'
  }
</script>

<script setup lang="ts">
  import { useGatForm } from '../gat-form/gat-form.vue'
  import { cn } from '../../lib/utils'
  const formContext = useGatForm()

  const props = defineProps<FieldStackProps>()
  const _fieldType = computed(
    () => props.fieldType || formContext.fieldType || 'default'
  )
</script>

<template>
  <div
    :class="
      cn(
        {
          'flex flex-col gap-3': !formContext.isProvided
        },
        props.class
      )
    "
  >
    <div
      v-if="_fieldType === 'inset'"
      class="[&>*:first-child]:rounded-t [&>*:focus-within]:relative [&>*:focus-within]:z-10 [&>*:last-child]:rounded-b [&>*:not(:last-child)]:-mb-px [&>*:only-child]:rounded [&>*]:rounded-none [&>*]:border [&>*]:border-neutral-300"
    >
      <slot />
    </div>
    <slot v-else />
  </div>
</template>
